export var EXPENSE_SORT_FIELDS;
(function (EXPENSE_SORT_FIELDS) {
    EXPENSE_SORT_FIELDS["DATE"] = "date";
    EXPENSE_SORT_FIELDS["CREATED_AT"] = "created_at";
    EXPENSE_SORT_FIELDS["REVIEWED_AT"] = "reviewed_at";
    EXPENSE_SORT_FIELDS["AMOUNT"] = "amount";
    EXPENSE_SORT_FIELDS["STATE"] = "state";
    // new fields
    EXPENSE_SORT_FIELDS["TRANSACTION_DATE"] = "transaction_date";
    EXPENSE_SORT_FIELDS["VENDOR"] = "vendor";
    EXPENSE_SORT_FIELDS["CATEGORY"] = "category";
    EXPENSE_SORT_FIELDS["USER_ID"] = "user_id";
    EXPENSE_SORT_FIELDS["POSTED_DATE"] = "posted_date";
    EXPENSE_SORT_FIELDS["TRIP"] = "trip";
    EXPENSE_SORT_FIELDS["STATEMENT_DATE"] = "statement_date";
    EXPENSE_SORT_FIELDS["EXPENSE_TAG"] = "expense_tag_bucket_id";
})(EXPENSE_SORT_FIELDS || (EXPENSE_SORT_FIELDS = {}));
export var TRANSACTION_SORT_FIELDS;
(function (TRANSACTION_SORT_FIELDS) {
    TRANSACTION_SORT_FIELDS["DATE"] = "date";
    TRANSACTION_SORT_FIELDS["VENDOR"] = "vendor";
    TRANSACTION_SORT_FIELDS["AMOUNT"] = "amount";
    TRANSACTION_SORT_FIELDS["STATE"] = "state";
    TRANSACTION_SORT_FIELDS["TRANSACTION_DATE"] = "transaction_date";
    TRANSACTION_SORT_FIELDS["CATEGORY"] = "category";
    TRANSACTION_SORT_FIELDS["USER_ID"] = "user_id";
    TRANSACTION_SORT_FIELDS["POSTED_DATE"] = "posted_date";
    TRANSACTION_SORT_FIELDS["STATEMENT_DATE"] = "statement_date";
    TRANSACTION_SORT_FIELDS["CREATED_AT"] = "created_at";
})(TRANSACTION_SORT_FIELDS || (TRANSACTION_SORT_FIELDS = {}));
export var ALLOWED_REIMBURSABLE_COLUMNS;
(function (ALLOWED_REIMBURSABLE_COLUMNS) {
    ALLOWED_REIMBURSABLE_COLUMNS["DATE"] = "date";
    ALLOWED_REIMBURSABLE_COLUMNS["USER_ID"] = "user_id";
    ALLOWED_REIMBURSABLE_COLUMNS["CATEGORY"] = "category";
    ALLOWED_REIMBURSABLE_COLUMNS["NOTE"] = "note";
    ALLOWED_REIMBURSABLE_COLUMNS["EXPENSE_RULE_WARNINGS"] = "expense_rule_warnings";
    ALLOWED_REIMBURSABLE_COLUMNS["IMAGE"] = "image";
    ALLOWED_REIMBURSABLE_COLUMNS["AMOUNT"] = "amount";
    ALLOWED_REIMBURSABLE_COLUMNS["STATE"] = "state";
    ALLOWED_REIMBURSABLE_COLUMNS["MANAGER"] = "manager";
    ALLOWED_REIMBURSABLE_COLUMNS["BILLABLE"] = "billable";
    ALLOWED_REIMBURSABLE_COLUMNS["TRIP"] = "trip";
    ALLOWED_REIMBURSABLE_COLUMNS["BUTTONS"] = "buttons";
})(ALLOWED_REIMBURSABLE_COLUMNS || (ALLOWED_REIMBURSABLE_COLUMNS = {}));
export var ALLOWED_TRANSACTION_COLUMNS;
(function (ALLOWED_TRANSACTION_COLUMNS) {
    ALLOWED_TRANSACTION_COLUMNS["VENDOR"] = "vendor";
    ALLOWED_TRANSACTION_COLUMNS["AMOUNT"] = "amount";
    ALLOWED_TRANSACTION_COLUMNS["NOTE"] = "note";
    ALLOWED_TRANSACTION_COLUMNS["CARD_DETAILS"] = "cardDetails";
    ALLOWED_TRANSACTION_COLUMNS["CATEGORY"] = "category";
    ALLOWED_TRANSACTION_COLUMNS["USER_ID"] = "user_id";
    ALLOWED_TRANSACTION_COLUMNS["IMAGE"] = "image";
    ALLOWED_TRANSACTION_COLUMNS["EXPENSE_RULE_WARNINGS"] = "expense_rule_warnings";
    ALLOWED_TRANSACTION_COLUMNS["STATE"] = "state";
    ALLOWED_TRANSACTION_COLUMNS["MANAGER"] = "manager";
    ALLOWED_TRANSACTION_COLUMNS["BILLABLE"] = "billable";
    ALLOWED_TRANSACTION_COLUMNS["SPLIT_TRANSACTION_ID"] = "split_transaction_id";
    ALLOWED_TRANSACTION_COLUMNS["POSTED_DATE"] = "posted_date";
    ALLOWED_TRANSACTION_COLUMNS["TRIP"] = "trip";
    ALLOWED_TRANSACTION_COLUMNS["STATEMENT_DATE"] = "statement_date";
    ALLOWED_TRANSACTION_COLUMNS["TRANSACTION_DATE"] = "transaction_date";
})(ALLOWED_TRANSACTION_COLUMNS || (ALLOWED_TRANSACTION_COLUMNS = {}));
export var ALLOWED_SORT_DIRECTION;
(function (ALLOWED_SORT_DIRECTION) {
    ALLOWED_SORT_DIRECTION["ASC"] = "asc";
    ALLOWED_SORT_DIRECTION["DESC"] = "desc";
})(ALLOWED_SORT_DIRECTION || (ALLOWED_SORT_DIRECTION = {}));
export var SECTION_NAME;
(function (SECTION_NAME) {
    SECTION_NAME["REIMBURSABLE_EXPENSE"] = "reimbursable_expense";
    SECTION_NAME["CARD_TRANSACTIONS"] = "card_transactions";
})(SECTION_NAME || (SECTION_NAME = {}));
export var SCOPE;
(function (SCOPE) {
    SCOPE["TEAM"] = "team";
    SCOPE["DELEGATE"] = "delegate";
    SCOPE["ME"] = "me";
})(SCOPE || (SCOPE = {}));
export var PREFERENCE_KEYS;
(function (PREFERENCE_KEYS) {
    PREFERENCE_KEYS["COLUMN_ORDER"] = "column_order";
    PREFERENCE_KEYS["COLUMN_VISIBILITY"] = "column_visibility";
    PREFERENCE_KEYS["SORT_FIELD"] = "sort_field";
    PREFERENCE_KEYS["SORT_DIRECTION"] = "sort_direction";
    PREFERENCE_KEYS["PAGE_SIZE"] = "page_size";
    PREFERENCE_KEYS["PINNED_COLUMNS"] = "pinned_columns";
})(PREFERENCE_KEYS || (PREFERENCE_KEYS = {}));
